<template>
    <div>
        <div class="grid-x grid-padding-x">
            <div
                class="cell small-12">
                <div class="grid-x grid-padding-x pad-top--small">
                    <div class="cell small-12 medium-6 medium-offset-2">
                        <h4 class="marg-bottom--xs">{{ garment.name }}</h4>
                    </div>
                </div>
                <div
                    v-for="colour in garment.colours"
                    v-bind:key="colour.id">
                    <div class="grid-x grid-padding-x pad-top--small">
                        <div class="cell small-12 medium-4 medium-offset-2">
                            <p class="lead marg-bottom--xs">
                                <strong
                                    v-bind:style="`color:#${colour.hex}`">
                                    {{ colour.colour }}
                                </strong>
                            </p>
                        </div>
                    </div>
                    <div
                        v-for="size in colour.sizes"
                        v-bind:key="size.id">
                        <div
                            v-for="(n, index) in size.quantity"
                            v-bind:key="index"
                            class="grid-x grid-padding-x pad-top--xs">
                            <div class="cell small-12 medium-2">
                                <p class="text-right pad-top--xs">Size: {{ size.size }}</p>
                            </div>
                            <div class="cell small-12 medium-4 float-left">
                                <input
                                    v-bind:data-iteration="n"
                                    v-bind:data-size-id="size.size_id"
                                    v-on:blur="saveName"
                                    type="text"
                                    placeholder="Name" />
                            </div>
                        </div>                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from '../../axios';

export default {
    props: [
        'garment',
    ],
    computed: {
        basketId() {
            return this.$store.getters.basketId;
        },
    },
    methods: {
        saveName(event) {
            const element = event.currentTarget;
            const postData = {};
            postData.basket_id = this.basketId;
            postData.size_id = element.getAttribute('data-size-id');
            postData.iteration = element.getAttribute('data-iteration');
            postData.name = element.value;
            axios.post('/GarmentColourSizesNames/saveName.json', postData);
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/Order/NameForm.vue